import React, { useState, useEffect, useContext, useRef, useCallback } from 'react'
import { Button, Drawer } from '@material-ui/core'
import './Message.css'
import ActiveSellers from './ActiveSellers'
import ActiveSubjects from './ActiveSubjects'
import Conversations from './Conversations'
import SearchNav from '../../components/molecules/SearchNav'
import CommonContext from '../../context/common/commonContext'
import AuthContext from '../../context/auth/authContext'
import { apiCall } from '../../common/api'
import openSocket from 'socket.io-client'

function Message() {
    const { getLangPhrase, language, phrase, getMsgUnreadCount } = useContext(CommonContext)
    const { user } = useContext(AuthContext)

    const [data, setData] = useState({
        parent: { activemsgcount: 0, archivemsgcount: 0 },
        sellers: {},
        conversations: {},
    })
    const [ui, setUI] = useState({
        isArchive: false,
        isLoading: true,
        drawerOpen: false,
        showSubjects: false,
    })
    const [activeSeller, setActiveSeller] = useState({ index: '', element: '' })
    const [activeProject, setActiveProject] = useState({ index: '', element: '', project_id: '' })
    const activeProjectRef = useRef(activeProject)
    const socketRef = useRef(null)
    const [activeTab, setActiveTab] = useState(null)
    const [firstTab, setFirstTab] = useState(null)
    const [convCount, setConvCount] = useState(0)
    const userIdRef = useRef(user.id)
    const markAsReadTimer = useRef(null)
    const unreadTimer = useRef(null)

    useEffect(() => {
        getLangPhrase(language)
        document.title = `${global.site_title} | Messages`
    }, [language])

    useEffect(() => {
        ;(async () => {
            setUI((p) => ({ ...p, isLoading: true }))
            const ok = await getParentMessageData()
            if (ok) setUI((p) => ({ ...p, isLoading: false }))
        })()
    }, [ui.isArchive])

    useEffect(() => {
        if (firstTab) setActiveTab(firstTab)
    }, [firstTab])

    // useEffect(() => {
    //     socketRef.current = openSocket(`${process.env.REACT_APP_DOMAIN}/`)
    //     socketRef.current.on('sendmessage', handleSocketMessage)
    //     return () => {
    //         socketRef.current.off('sendmessage', handleSocketMessage)
    //         socketRef.current.disconnect()
    //     }
    // }, [activeSeller])

    // const handleSocketMessage = useCallback(
    //     (msg) => {
    //         if (
    //             String(msg.to_id) !== String(user.id) ||
    //             String(msg.projectmsgpost) !== String(activeProjectRef.current.project_id)
    //         ) {
    //             return
    //         }
    //         const attachName =
    //             msg.attachinsidename || (msg.file_url ? msg.file_url.split('/').pop() : '') || ''
    //         const today = new Date().toISOString().split('T')[0]

    //         if (activeProjectRef.current.project_id === msg.projectmsgpost) {
    //             setData((prev) => {
    //                 const newMsg = {
    //                     id: msg.message_id || Date.now(),
    //                     from_id: msg.from_id,
    //                     message: msg.message || '',
    //                     date_sent: new Date().toISOString(),
    //                     image: attachName ? 1 : 0,
    //                     img_basename: attachName,
    //                     img_origname: msg.file_name || '',
    //                     raw_file_url: msg.file_url || null,
    //                 }

    //                 const messages = prev.conversations.actualmessages || []
    //                 const idx = messages.findIndex((c) => c.date === today)
    //                 let updated = [...messages]

    //                 if (idx >= 0) {
    //                     const duplicate = updated[idx].datearray.some(
    //                         (m) => String(m.id) === String(newMsg.id),
    //                     )
    //                     if (!duplicate) updated[idx].datearray.push(newMsg)
    //                 } else {
    //                     updated.push({ date: today, datearray: [newMsg] })
    //                 }

    //                 return {
    //                     ...prev,
    //                     conversations: { ...prev.conversations, actualmessages: updated },
    //                 }
    //             })
    //         } else {
    //             setData((p) => ({
    //                 ...p,
    //                 parent: { ...p.parent, archivemsgcount: p.parent.archivemsgcount + 1 },
    //             }))
    //             getParentMessageData()
    //             getMsgUnreadCount()
    //         }
    //     },
    //     [user.id],
    // )

    useEffect(() => {
        userIdRef.current = user.id
    }, [user.id])

    useEffect(() => {
        socketRef.current = openSocket(`${process.env.REACT_APP_DOMAIN}/`, {
            transports: ['websocket'],
        })

        const onSendMessage = (msg) => {
            if (String(msg.to_id) !== String(userIdRef.current)) return

            const incomingProjectId = String(msg.projectmsgpost || '')
            const attachName =
                msg.attachinsidename || (msg.file_url ? msg.file_url.split('/').pop() : '') || ''
            const today = new Date().toISOString().split('T')[0]

            //Message belongs to currently open project
            if (String(activeProjectRef.current.project_id) === incomingProjectId) {
                const newMsg = {
                    id: msg.message_id || Date.now(),
                    from_id: msg.from_id,
                    message: msg.message || '',
                    date_sent: new Date().toISOString(),
                    image: attachName ? 1 : 0,
                    img_basename: attachName,
                    img_origname: msg.file_name || '',
                    raw_file_url: msg.file_url || null,
                }

                setData((prev) => {
                    const messages = prev.conversations.actualmessages || []
                    const idx = messages.findIndex((c) => c.date === today)
                    const updated = [...messages]

                    if (idx >= 0) {
                        const duplicate = updated[idx].datearray.some(
                            (m) => String(m.id) === String(newMsg.id),
                        )
                        if (!duplicate) {
                            updated[idx] = {
                                ...updated[idx],
                                datearray: [...updated[idx].datearray, newMsg],
                            }
                        }
                    } else {
                        updated.push({ date: today, datearray: [newMsg] })
                    }

                    return {
                        ...prev,
                        conversations: { ...prev.conversations, actualmessages: updated },
                    }
                })
                return
            }

            //Message for another project — increment unread counts
            setData((prev) => {
                const newParent = {
                    ...prev.parent,
                    activemsgcount: (prev.parent.activemsgcount || 0) + 1,
                }

                // Clone the full sellers list
                const sellersCopy = prev.parent?.messagesforusers
                    ? [...prev.parent.messagesforusers]
                    : []

                // find which seller this message belongs to
                const sellerId = msg.seller_id || msg.from_id

                // increment unread for that seller
                const updatedSellers = sellersCopy.map((s) =>
                    String(s.userid || s.seller_id) === String(sellerId)
                        ? { ...s, unreadcount: (s.unreadcount || 0) + 1 }
                        : s,
                )

                // also update project-level unread
                const sellerData = prev.sellers ? { ...prev.sellers } : prev.sellers
                if (sellerData?.projectmessages?.length) {
                    sellerData.projectmessages = sellerData.projectmessages.map((p) =>
                        String(p.project_id) === incomingProjectId
                            ? { ...p, unreadcount: (p.unreadcount || 0) + 1 }
                            : p,
                    )
                }

                return {
                    ...prev,
                    parent: { ...newParent, messagesforusers: updatedSellers },
                    sellers: sellerData,
                }
            })

            //Refresh header unread count for other convos (debounced)
            clearTimeout(unreadTimer.current)
            unreadTimer.current = setTimeout(() => {
                getMsgUnreadCount()
            }, 300)
        }

        socketRef.current.on('sendmessage', onSendMessage)

        return () => {
            if (socketRef.current) {
                socketRef.current.off('sendmessage', onSendMessage)
                socketRef.current.disconnect()
                socketRef.current = null
            }
        }
    }, [])

    const getParentMessageData = async () => {
        const res = await apiCall('get', '', { archive: ui.isArchive }, '', 'messages')
        if (res.data.success) {
            setData((prev) => ({ ...prev, parent: res.data.data }))
            return true
        }
    }
    const getProjectMessageData = async (seller_id) => {
        const res = await apiCall(
            'post',
            '',
            { sellerid: seller_id, archive: ui.isArchive },
            '',
            'searchprojectmessages',
        )
        if (res.data.success) {
            setData((prev) => ({ ...prev, sellers: res.data.data }))
            return res.data.data
        }
        return null
    }

    const getConversationData = async (seller_id, project_id, unreadCount = '') => {
        const body = { sellerid: seller_id, projectid: project_id, archive: ui.isArchive }
        if (unreadCount) {
            body.activemainusertunread = unreadCount
            body.activesellerunread = unreadCount
        }
        const res = await apiCall('post', '', body, '', 'searchactualmessages')
        if (res.data.success) {
            setData((prev) => ({ ...prev, conversations: res.data.data }))
            return true
        }
        return false
    }

    const reset = async (seller_id, project_id, unreadCount) => {
        await getParentMessageData()
        await getProjectMessageData(seller_id)
        // if (project_id) await getConversationData(seller_id, project_id)
        if (unreadCount > 0) {
            getMsgUnreadCount()
        }
    }

    const handleMessageSubmit = async (message, seller_id, project_id, uploadedFile) => {
        const tempIdBase = Date.now()
        const today = new Date().toISOString().split('T')[0]

        const newImageMessage = uploadedFile
            ? {
                  id: `${tempIdBase}_image`,
                  message: '',
                  from_id: user.id,
                  date_sent: new Date().toISOString(),
                  image: 1,
                  img_basename: uploadedFile.name,
                  img_origname: uploadedFile.name,
                  raw_file_url: URL.createObjectURL(uploadedFile),
                  temp: true,
              }
            : null

        const newTextMessage = {
            id: `${tempIdBase}_text`,
            message,
            from_id: user.id,
            date_sent: new Date().toISOString(),
            image: 0,
            temp: true,
        }

        setData((prev) => {
            const messages = prev.conversations.actualmessages || []
            const idx = messages.findIndex((c) => c.date === today)
            let updated = [...messages]

            if (idx >= 0) {
                if (newImageMessage) updated[idx].datearray.push(newImageMessage)
                updated[idx].datearray.push(newTextMessage)
            } else {
                updated.push({
                    date: today,
                    datearray: [...(newImageMessage ? [newImageMessage] : []), newTextMessage],
                })
            }

            return { ...prev, conversations: { ...prev.conversations, actualmessages: updated } }
        })

        try {
            const body = {
                sellermsgpost: seller_id,
                projectmsgpost: project_id,
                message,
                status: 'open',
                fromadmin: 0,
            }
            const headers = { imagesession: '1' }

            if (uploadedFile) {
                const fd = new FormData()
                fd.append('ig_messages_upload', uploadedFile)
                const uploadRes = await apiCall(
                    'post',
                    'addnewattach/1',
                    fd,
                    'formdata',
                    'messages',
                    headers,
                )
                if (uploadRes.data?.datumnew) {
                    body.attachinsidename = uploadRes.data.datumnew.name
                    body.attachorginalname = uploadRes.data.datumnew.originalname
                }
                await apiCall('post', 'saveattachementmessage', body, '', 'messages', headers)
            }

            const saveRes = await apiCall('post', 'savemessage', body, '', 'messages', headers)

            if (saveRes.data.success) {
                setData((prev) => {
                    const messages = prev.conversations.actualmessages || []
                    const idx = messages.findIndex((c) => c.date === today)
                    let updated = [...messages]

                    if (idx >= 0) {
                        updated[idx].datearray = updated[idx].datearray.map((msg) =>
                            msg.id === `${tempIdBase}_image`
                                ? {
                                      ...msg,
                                      id: saveRes.data.message_id || msg.id,
                                      temp: false,
                                      img_basename: body.attachinsidename || msg.img_basename,
                                      img_origname: body.attachorginalname || msg.img_origname,
                                      raw_file_url: body.attachinsidename
                                          ? `${global.site_url}/uploads/messages/${body.attachinsidename}`
                                          : msg.raw_file_url,
                                      date_sent: new Date().toISOString(),
                                  }
                                : msg.id === `${tempIdBase}_text`
                                ? {
                                      ...msg,
                                      id: saveRes.data.message_id || msg.id,
                                      temp: false,
                                      date_sent: new Date().toISOString(),
                                  }
                                : msg,
                        )
                    }

                    return {
                        ...prev,
                        conversations: { ...prev.conversations, actualmessages: updated },
                    }
                })

                setData((prev) => {
                    const sellers = { ...prev.sellers }
                    if (sellers.projectmessages?.length) {
                        sellers.projectmessages = sellers.projectmessages.map((p) =>
                            p.project_id === activeProjectRef.current.project_id
                                ? { ...p, conversationcount: (p.conversationcount || 0) + 1 }
                                : p,
                        )
                    }
                    return { ...prev, sellers }
                })
            }
        } catch (error) {
            setData((prev) => {
                const messages = prev.conversations.actualmessages || []
                const idx = messages.findIndex((c) => c.date === today)
                let updated = [...messages]

                if (idx >= 0) {
                    updated[idx].datearray = updated[idx].datearray.filter(
                        (msg) =>
                            msg.id !== `${tempIdBase}_text` && msg.id !== `${tempIdBase}_image`,
                    )
                }

                return {
                    ...prev,
                    conversations: { ...prev.conversations, actualmessages: updated },
                }
            })
        }
    }

    const handleMessageDelete = async (id, seller_id, project_id) => {
        const res = await apiCall('post', '', { id }, '', 'messages/deletemessage')
        if (res.data.success) reset(seller_id, project_id, '')
    }

    const handleArchive = async (seller_id, project_id, unarchive = false) => {
        const body = { sellerid: seller_id, projectid: project_id, archive: unarchive }
        const res = await apiCall('post', '', body, '', 'messages/archivemessages')
        if (res.data.success) unarchive ? firstTab?.click() : reset(seller_id, project_id, '')
    }

    const toggleArchiveTab = (e, archive) => {
        setUI((p) => ({ ...p, isArchive: archive }))
        activeTab?.classList.remove('active')
        e.currentTarget.classList.add('active')
        setActiveTab(e.currentTarget)
    }

    const sellerClickHandler = async (e, index, seller_id, autoSelectFirstProject = true) => {
        e?.persist()
        const ok = await getProjectMessageData(seller_id)
        if (ok) {
            getMsgUnreadCount()
            activeSeller.element?.classList?.remove('active')
            e?.currentTarget?.classList.add('active')
            setActiveSeller({ index, element: e?.currentTarget })

            if (autoSelectFirstProject) {
                const firstProject = ok.projectmessages?.[0]
                if (firstProject) {
                    await projectClickHandler(
                        null,
                        0,
                        seller_id,
                        firstProject.unreadcount,
                        firstProject.project_id,
                        true,
                    )
                }
            }
        }
    }

    const projectClickHandler = async (
        e,
        index,
        seller_id,
        unread,
        project_id,
        autoLoadConversations = false,
    ) => {
        const element = e?.currentTarget || null
        const ok = await getConversationData(seller_id, project_id, unread)
        if (ok) {
            //Immediately update local unread counts so UI updates without tab switch
            setData((prev) => {
                const sellersCopy = prev.sellers ? { ...prev.sellers } : prev.sellers
                const parentCopy = { ...prev.parent }

                if (sellersCopy?.projectmessages?.length) {
                    const proj = sellersCopy.projectmessages[index]
                    const prevUnread = proj?.unreadcount || 0

                    if (prevUnread > 0) {
                        // reset this project’s unread count to 0
                        sellersCopy.projectmessages = sellersCopy.projectmessages.map((p, i) =>
                            i === index ? { ...p, unreadcount: 0 } : p,
                        )

                        // adjust total message counters (active/archive)
                        if (!ui.isArchive) {
                            parentCopy.activemsgcount = Math.max(
                                (parentCopy.activemsgcount || 0) - prevUnread,
                                0,
                            )
                        } else {
                            parentCopy.archivemsgcount = Math.max(
                                (parentCopy.archivemsgcount || 0) - prevUnread,
                                0,
                            )
                        }

                        // also reduce unread for that seller
                        if (parentCopy.messagesforusers?.length) {
                            parentCopy.messagesforusers = parentCopy.messagesforusers.map((u) => {
                                if (String(u.userid || u.seller_id) === String(seller_id)) {
                                    return {
                                        ...u,
                                        unreadcount: Math.max((u.unreadcount || 0) - prevUnread, 0),
                                    }
                                }
                                return u
                            })
                        }
                    }
                }

                return { ...prev, sellers: sellersCopy, parent: parentCopy }
            })

            //Highlight the active project in UI
            activeProject.element?.classList?.remove('active')
            if (element) element.classList.add('active')

            const newProj = { index, element, project_id }
            setActiveProject(newProj)
            activeProjectRef.current = newProj
            const project = data.sellers?.projectmessages?.[index]
            if (project) setConvCount(project.conversationcount || 0)

            if (autoLoadConversations) {
                setData((prev) => ({ ...prev, conversations: prev.conversations }))
            }
            // still refresh unread counts from backend later (optional)
            getMsgUnreadCount()
        }
    }

    const renderMessageSection = (isArchive) => {
        const { parent, sellers, conversations } = data
        const activeCount = isArchive ? parent.archivemsgcount : parent.activemsgcount
        if (ui.isLoading) return <div className="nomessage">Loading...</div>
        if (!activeCount) return <div className="nomessage">{phrase.no_new_messages}</div>

        const projectTitle = sellers.projectmessages?.[activeProject.index]?.title || ''
        const convCount = sellers.projectmessages?.[activeProject.index]?.conversationcount || 0

        return (
            <>
                <div className="messageHead d-flex justify-content-between align-items-center flex-wrap">
                    <Button
                        className="toggleSellers"
                        onClick={() => setUI((p) => ({ ...p, drawerOpen: true }))}
                    >
                        <span className="material-icons">people_alt</span> Show Sellers
                    </Button>
                    <h4>{phrase.sellers}</h4>
                    <h5>{`${phrase.conversations} - ${projectTitle}`}</h5>
                    <h6>{`${convCount} ${phrase.conversations}`}</h6>
                </div>
                <div className="messageBody d-flex justify-content-start">
                    <ActiveSellers
                        sellers={data.parent.messagesforusers}
                        onClick={sellerClickHandler}
                        onFirstSellerLoaded={(firstSellerId) =>
                            getProjectMessageData(firstSellerId)
                        }
                        isArchive={ui.isArchive}
                        activeSeller={activeSeller}
                    />
                    <ActiveSubjects
                        sellerMessages={sellers}
                        phrase={phrase}
                        onClick={projectClickHandler}
                        isArchive={isArchive}
                        handleUnarchiveButtonClick={(sid, pid) => handleArchive(sid, pid, true)}
                        handleArchiveButtonClick={(sid, pid) => handleArchive(sid, pid)}
                        activeProjectIndex={activeProject.index}
                    />
                    <Conversations
                        conversations={conversations}
                        handleMessageSubmit={handleMessageSubmit}
                        handleMessageDelete={handleMessageDelete}
                        phrase={phrase}
                    />
                </div>
            </>
        )
    }

    return (
        <>
            <SearchNav />
            <div className="messages">
                <div className="container-lg">
                    <div className="messageTop d-flex justify-content-between align-items-center">
                        <h2>{phrase.all_messages}</h2>
                        <div>
                            <Button
                                className="active"
                                onClick={(e) => toggleArchiveTab(e, false)}
                                ref={setFirstTab}
                            >
                                {`${phrase.active} (${data.parent.activemsgcount})`}
                            </Button>
                            <Button onClick={(e) => toggleArchiveTab(e, true)}>
                                {`${phrase.archive} (${data.parent.archivemsgcount})`}
                            </Button>
                        </div>
                    </div>
                    <div className="messageCnt">{renderMessageSection(ui.isArchive)}</div>
                </div>
            </div>

            <Drawer
                anchor="left"
                open={ui.drawerOpen}
                onClose={() => setUI((p) => ({ ...p, drawerOpen: false }))}
                className="msgDrawer"
            >
                <h4 className="msgHead">
                    {ui.showSubjects
                        ? phrase['active_conversations'] || 'Active Conversations'
                        : phrase['active_sellers'] || 'Active Sellers'}
                </h4>
                {ui.showSubjects ? (
                    <>
                        <Button
                            className="backSellerBtn"
                            onClick={() => setUI((p) => ({ ...p, showSubjects: false }))}
                        >
                            <span className="material-icons">arrow_back</span>Back to Sellers
                        </Button>
                        <ActiveSubjects
                            sellerMessages={data.sellers}
                            phrase={phrase}
                            onClick={projectClickHandler}
                            isArchive={ui.isArchive}
                            handleUnarchiveButtonClick={(sid, pid) => handleArchive(sid, pid, true)}
                            handleArchiveButtonClick={(sid, pid) => handleArchive(sid, pid)}
                            activeProjectIndex={activeProject.index}
                        />
                    </>
                ) : (
                    <div onClick={() => setUI((p) => ({ ...p, showSubjects: true }))}>
                        <ActiveSellers
                            sellers={data.parent.messagesforusers}
                            onClick={sellerClickHandler}
                            onFirstSellerLoaded={(firstSellerId) =>
                                getProjectMessageData(firstSellerId)
                            }
                            isArchive={ui.isArchive}
                            activeSeller={activeSeller}
                        />
                    </div>
                )}
            </Drawer>
        </>
    )
}

export default Message
